import { BP42SubmitResult } from '@r1-frontend/bp42/actions/thunk/submit';
import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

const getSubmitResult = (state: BP42InitialState): BP42SubmitResult => state._submitResult;

export default getSubmitResult;
